import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import AboutUs from "./components/AboutUs";
import MissionVision from "./components/MissionVision";
import Services from "./components/Services";
import Products from "./components/Products";


import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import CategoryPage from "./components/CategoryPage";
import AllProducts from "./components/AllProducts";
import ProductDetails from "./components/ProductDetails";

const HomePage = () => (
  <>
    <MissionVision />
    <Services />
    <Products />
    <AboutUs />
    <ContactUs />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Navbar />
        <main className="relative pt-20">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products/:category" element={<CategoryPage />} />
            <Route path="/all-products" element={<AllProducts />} />
            <Route path="/product-details/:category" element={<ProductDetails />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
